import { FC } from 'react';
import { RouteComponentProps } from 'react-router';
import { SortingContextProvider } from 'utils/contexts/sorting';

import { SnippetReferences } from './SnippetReferences';
import { defaultSortField } from '../constants';
import { SnippetReferencesFilterContextProvider } from '../context/SnippetReferencesFilterContextProvider';
import { ReferencesPaginationContextProvider } from '../context/ReferencesPaginationContextProvider';

export const SnippetReferencesContext: FC<React.PropsWithChildren<RouteComponentProps>> = (
  props,
) => {
  return (
    <ReferencesPaginationContextProvider>
      <SnippetReferencesFilterContextProvider>
        <SortingContextProvider defaultSortField={defaultSortField}>
          <SnippetReferences {...props} />
        </SortingContextProvider>
      </SnippetReferencesFilterContextProvider>
    </ReferencesPaginationContextProvider>
  );
};
